/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreatePlayerNoteCommand } from '../../models/create-player-note-command';
import { PlayerNoteDtoResult } from '../../models/player-note-dto-result';

export interface ApiPlayerNotesPost$JsonOdataMetadataMinimalOdataStreamingTrue$Json$Params {
      body?: CreatePlayerNoteCommand
}

export function apiPlayerNotesPost$JsonOdataMetadataMinimalOdataStreamingTrue$Json(http: HttpClient, rootUrl: string, params?: ApiPlayerNotesPost$JsonOdataMetadataMinimalOdataStreamingTrue$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<PlayerNoteDtoResult>> {
  const rb = new RequestBuilder(rootUrl, apiPlayerNotesPost$JsonOdataMetadataMinimalOdataStreamingTrue$Json.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json;odata.metadata=minimal;odata.streaming=true');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlayerNoteDtoResult>;
    })
  );
}

apiPlayerNotesPost$JsonOdataMetadataMinimalOdataStreamingTrue$Json.PATH = '/api/player-notes';
